export default {
  'menu.visualization.dataAnalysis': 'Analysis',
  'dataAnalysis.title.publicOpinion': 'Public Opinion Analysis',
  'dataAnalysis.card.title.allVisitors': 'All Visitors',
  'dataAnalysis.card.title.contentPublished': 'Content Published',
  'dataAnalysis.card.title.totalComment': 'Total Comment',
  'dataAnalysis.card.title.totalShare': 'Total Share',
  'dataAnalysis.card.yesterday': 'Yesterday',
  'dataAnalysis.contentPublishRatio': 'Content Publishing Ratio',
  'dataAnalysis.popularAuthor': 'Popular Author',
  'dataAnalysis.popularAuthor.column.ranking': 'ranking',
  'dataAnalysis.popularAuthor.column.author': 'author',
  'dataAnalysis.popularAuthor.column.content': 'Content Number',
  'dataAnalysis.popularAuthor.column.click': 'Click Number',
  'dataAnalysis.contentPeriodAnalysis': 'Content Period Analysis',
};
